$(document).on('click', '.open_modal_product_alert', function () {
    product_id=$("#"+this.id).attr('data-product_id');
    if($("#product_alert"+product_id).attr('data-isinalert')==='1') {
        $('#modal_product_alert_delete'+product_id).addClass('show');
    }else{
        $('#modal_product_alert_add'+product_id).addClass('show');
    }
});

$(document).on('click', '.product_alert_change', function () {
    product_id=$("#"+this.id).attr('data-product_id');
    document.getElementById('modal_content_product_alert_add'+product_id).style.display='none';
    document.getElementById('modal_alerts_footer_add'+product_id).style.display='none';
    document.getElementById('modal_alerts_subtitle'+product_id).style.display='none';
    document.getElementById('modal_alerts_loading_add'+product_id).style.display='block';
    document.getElementById('modal_alerts_footer_delete'+product_id).style.display='none';
    document.getElementById('modal_alerts_loading_delete'+product_id).style.display='block';

    isactivealert=0;
    if($('#alert_mail'+product_id).is(":checked")){
        isactivealert=1;
    }

    $.ajax({
        url: ALERT_PRODUCT_CHANGE,
        method: 'POST',
        data: {
            _token: csrf_token,
            product_id: product_id,
            isinalert: $("#product_alert"+product_id).attr("data-isinalert"),
            isactivealert: isactivealert
        },
        success: function (response) {
            if(response.slice(0,9)==='<!DOCTYPE'){
                //Si le retour html commence par <!DOCTYPE il y a une erreur de connexion -> redirection page connexion
                window.location.replace(url_connection);
            }else{
                $('#modal_product_alert_add' + product_id).removeClass('show');
                $('#modal_product_alert_delete' + product_id).removeClass('show');
                if (response[0] === 'add' || response[0] === 'delete') {
                    if (response[0] === 'add') {
                        $("#product_alert" + product_id).attr("data-isinalert", 1);
                        $("#icon_bell" + product_id).removeClass('icon-bell').addClass('icon-bell-full');
                    } else {
                        $("#product_alert" + product_id).attr("data-isinalert", 0);
                        $("#icon_bell" + product_id).removeClass('icon-bell-full').addClass('icon-bell');
                    }
                    $("#display_product_alert" + product_id).html(response[1]);
                } else {
                    $("#display_product_alert" + product_id).html(response[1]);
                }
                if (response[2] === 1) {
                    document.getElementById('modal_content_product_alert_add' + product_id).style.display = 'none';
                    $('.modal_content_product_alert_add').css('display', 'none');
                } else {
                    document.getElementById('modal_content_product_alert_add' + product_id).style.display = 'block';
                    $('.modal_content_product_alert_add').css('display', 'block');
                }
                document.getElementById('modal_alerts_footer_add' + product_id).style.display = 'block';
                document.getElementById('modal_alerts_subtitle' + product_id).style.display = 'block';
                document.getElementById('modal_alerts_loading_add' + product_id).style.display = 'none';
                document.getElementById('modal_alerts_footer_delete' + product_id).style.display = 'block';
                document.getElementById('modal_alerts_loading_delete' + product_id).style.display = 'none';
                setTimeout(function () {
                    if (document.getElementById("modal_alert_info")) {
                        document.getElementById("modal_alert_info").remove();
                    }
                }, 3000);
            }
        },
        error: function (){
            //Utilisateur déconnecté sur une autre page, utilisateur désactivé ou utilisateur sans société -> redirigé sur la page de connexion
            window.location.replace(url_connection);
        }
    });
});
$(document).ready(function () {
    $("#alert_products_id").select2({
        placeholder: NO_PRODUCTS_SELECTED,
        dropdownCssId: "select2_products_id",
        dropdownCssClass: "openselectonmodal",
    });
});
$('#species_id').change(function(){
    $('#product_alert_add').removeClass('disabled').prop('disabled', false);
    var species_id = $(this).val();
    if(species_id){
        //Cache les produits qui ne font pas partie de l'espèce sélectionnée
        $('#alert_products_id option').prop('disabled', 'disabled');
        $('#alert_products_id option[data-species='+species_id+']').prop('disabled', false);
        $('#alert_products_id').find("option:not([disabled]):eq(0)");
    }else{
        //Aucune espèce sélectionnée tous les produits sont disponibles
        $('#alert_products_id option').prop('disabled', false);
    }
    //Cache des produits qui sont déjà en alerte
    var messages = document.querySelectorAll("#alert_products_id .disabled");
    for (var i = 0; i < messages.length; i++) {
        $("#"+messages[i].id).prop('disabled', 'disabled');
    }

    product_new_select();
});

$(".save_alerts_config").on('click', function() {
    type=$("#"+this.id).attr('data-type');
    if(this.checked){
        active=1;
    }else{
        active=0;
    }
    $.ajax({
        url: ALERT_CONFIG,
        method: 'POST',
        data: {
            _token: csrf_token,
            type: type,
            active: active
        },
        success: function (response) {
            $("#alert_config").html(response);
            setTimeout(function() {
                if(document.getElementById("modal_alert_config")){
                    document.getElementById("modal_alert_config").remove();
                }
            }, 3000);
        }
    });
});
$("#open_modal_add_product_alert").on('click', function() {
    $('#add_product_alert').addClass('show');
});

var alert_products_id=document.getElementById("alert_products_id");
if(alert_products_id){
    document.getElementById("alert_products_id").onchange=product_selected;
    function product_selected(){
        $('#product_alert_add').removeClass('disabled').prop('disabled', false);
    }
}

$("#product_alert_add").on('click', function() {
    document.getElementById('modal_content_product_alert').style.display='none';
    document.getElementById('modal_alerts_footer').style.display='none';
    document.getElementById('modal_alerts_loading').style.display='block';

    if(!$("#species_id").val()){
        //Réécriture du nom de la première option qui est supprimée dès l'ajout du produit si aucune espèce sélectionnée
        $("#product_id_noselected").html(NO_PRODUCTS_SELECTED);
        $('#product_alert_add').addClass('disabled').prop('disabled', 'disabled');
    }

    products_id=$("#alert_products_id").val()??null;
    if(products_id){
        $.ajax({
            url: ALERT_PRODUCT,
            method: 'POST',
            data: {
                _token: csrf_token,
                product_id: products_id
            },
            success: function (response) {
                $('#add_product_alert').removeClass('show');
                if(typeof response==='object'){
                    //Cache du produit ajouté dans le select
                    $('#alert_products_id option[id=product_option'+products_id+']').prop('disabled', 'disabled');
                    product_new_select();
                    //Ajout de tous les produits en alerte
                    var list_products='';
                    Object.keys(response).forEach(key => {
                        list_products+='<tr class="item_products" id="item'+response[key]['product_id']+'"><td colspan="9" class="align-middle"><a href="'+response[key]['product_url']+'" title="'+VIEW_PRODUCT_PAGE+'">'+response[key]['product_name']+'</a></td><td colspan="2" class="align-middle">'+response[key]['categorie_name']+'</td><td colspan="1" class="text-center" id="product_alert_delete'+response[key]['product_id']+'"><div class="delete_btn_alert btn product_alert_delete" data-product_id="'+response[key]['product_id']+'" title="'+DELETE_ALERT_PRODUCT+'"><span class="icon-trash"></span></div></td></tr>';
                    });
                    $("#list_products_alert").html(list_products);
                    document.getElementById('table_alert_products').style.visibility='visible';
                    $('#product_option'+products_id).addClass('disabled');

                    $(".product_alert_delete").on('click', function() {
                        product_alert_delete(this);
                    });

                }else{
                    $("#alert_message").html(response);
                    setTimeout(function() {
                        if(document.getElementById("modal_alert_info")){
                            document.getElementById("modal_alert_info").remove();
                        }
                    }, 3000);
                    $('#product_alert_add').removeClass('disabled').prop('disabled', false);
                }

                //Réaffichage du contenu de la modale
                document.getElementById('modal_content_product_alert').style.display='block';
                document.getElementById('modal_alerts_footer').style.display='block';
                document.getElementById('modal_alerts_loading').style.display='none';
            },
            error: function (){
                //Utilisateur déconnecté sur une autre page, utilisateur désactivé ou utilisateur sans société -> redirigé sur la page de connexion
                window.location.href=url_connection;
            }
        });
    }else{
        //Aucun produit envoyé
        document.getElementById('modal_content_product_alert').style.display='block';
        document.getElementById('modal_alerts_footer').style.display='block';
        document.getElementById('modal_alerts_loading').style.display='none';
    }
});

$(".product_alert_delete").on('click', function() {
    product_alert_delete(this);
});
function product_alert_delete(line_product_delete){
    product_id=$("#"+line_product_delete.parentElement.id).children().attr('data-product_id');
    product_alert_delete_loading='<div class="spinner-border" role="status" id="modal_alerts_loading"><span class="visually-hidden">'+LOADING+'</span></div>';
    $("#product_alert_delete"+product_id).html(product_alert_delete_loading);

    $.ajax({
        url: ALERT_DELETE,
        method: 'POST',
        data: {
            _token: csrf_token,
            product_id: product_id
        },
        success: function (response) {
            if(typeof response=='object' && response[0]==='deleted'){
                //Le produit est supprimé des alertes et de nouveau disponible dans le select
                document.getElementById("item"+response[2]).remove();
                $species_id_val=$('#species_id').val();
                $species_id_product_deleted=document.querySelector('#alert_products_id [value="'+response[2]+'"]').getAttribute('data-species');
                $('#product_option'+response[2]).removeClass('disabled');

                if($species_id_val==='' || $species_id_val===$species_id_product_deleted){
                    //Aucune espèce sélectionnée ou l'espèce sélectionnée est celle du produit qui vient d'être supprimé -> le produit doit être de nouveau visible dans le select
                    $('#alert_products_id option[id=product_option'+response[2]+']').prop('disabled', false);
                    //Nouvelle sélection du premier produit disponible
                    product_new_select();
                }

                if(response[1]===0) {
                    document.getElementById('table_alert_products').style.visibility = 'hidden';
                }
            }else{
                $("#alert_message").html(response);
                setTimeout(function() {
                    document.getElementById("modal_alert_info").remove();
                }, 3000);
            }
        }
    });
}

//Resélection du premier produit disponible dans select2
function product_new_select(){
    new_select=$('#alert_products_id option:not([disabled]):first');
    document.getElementById('alert_products_id').value = new_select.val();
    document.getElementById('select2-alert_products_id-container').title = new_select.text();
    document.getElementById('select2-alert_products_id-container').textContent = new_select.text();
}
